module.exports = __webpack_public_path__ + "static/media/bike3a.7ca9f7e3.jpg";